import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { PaymentLink } from './payment-link.entity'

export class PaymentLinksRepository extends BaseRepository<PaymentLink> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.paymentApiUrl + '/links', token, cache)
    }
}
